import type { IconData } from '@stacksjs/iconify-core'

export const kp1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGeZuureQS\"><path fill-opacity=\".7\" d=\"M92.2 7.8h593.6v485.5H92.2z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGeZuureQS)\" transform=\"matrix(.86254 0 0 1.0546 -79.5 -8.3)\"><path fill=\"#fff\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M991.8 492.9H4.2V8.4h987.6z\"/><path fill=\"#3e5698\" d=\"M991.8 405.2H4.2V493h987.6z\"/><path fill=\"#c60000\" d=\"M991.8 384.9H4.2V116.4h987.6z\"/><path fill=\"#3e5698\" d=\"M991.8 8.4H4.2V96h987.6z\"/><path fill=\"#fff\" d=\"M473 250.7c0 60.1-61.5 108.9-137.4 108.9S198 310.8 198 250.6c0-60.1 61.6-108.9 137.6-108.9S473 190.5 473 250.7\"/><path fill=\"#c40000\" d=\"m402.9 326.8l-66.1-38.6l-67.1 39l26.3-62.8l-66.1-38.5l82.4-.3l26.2-63l24.5 62.8l82.4-.4l-67.2 39z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default kp1x1
